export const BEAT_SOUNDS = Object.freeze([
  { id: 'metronome', name: 'Mechanical metronome', file: '/sounds/rhythm/metronome.wav' },
  { id: 'sticks', name: 'Drumsticks', file: '/sounds/rhythm/drumsticks.wav' },
  { id: 'beep', name: 'Electronic beep' },
]);
export const isBeatSound = sound => BEAT_SOUNDS.some(option => option.id === sound);
export const countdownSound = settings => settings.countdownSound ?? (settings.countdownBeep === false ? 'silent' : settings.countdownBeep === true ? 'beep' : 'metronome');
